module.exports = __webpack_public_path__ + "img/yaguangmochoubiandai.min.e121d334.png";